module.exports = __webpack_public_path__ + "static/thumb-333ec05f1d88aa3dcdefa07917da973f.jpg";